import { geoNaturalEarth1, geoMercator, GeoProjection } from 'd3-geo'

// Note: d3-geo's geoEqualEarth is not available in all bundled versions;
// geoNaturalEarth1 is a widely supported, visually similar pseudo-cylindrical
// world projection. Swap to geoEqualEarth later if/when the dep is upgraded.
export function getEqualEarthProjection(
  width: number,
  height: number,
): GeoProjection {
  return geoNaturalEarth1()
    .scale(Math.min(width, height) * 0.4)
    .translate([width / 2, height / 2])
}

export function getMercatorNLProjection(
  width: number,
  height: number,
): GeoProjection {
  return geoMercator()
    .center([5.4, 52.2])
    .scale(Math.min(width, height) * 12)
    .translate([width / 2, height / 2])
}

export function getMercatorWaddenProjection(
  width: number,
  height: number,
): GeoProjection {
  // Centered between Texel and Schiermonnikoog, zoomed in to show
  // all 5 Wadden islands plus the top edge of the mainland.
  return geoMercator()
    .center([5.55, 53.25])
    .scale(Math.min(width, height) * 35)
    .translate([width / 2, height / 2])
}

export function getMercatorEUProjection(
  width: number,
  height: number,
): GeoProjection {
  return geoMercator()
    .center([10, 50])
    .scale(Math.min(width, height) * 1.5)
    .translate([width / 2, height / 2])
}

export function pickProjection(
  mapId: string,
  width: number,
  height: number,
): GeoProjection {
  if (mapId === 'nl-islands') return getMercatorWaddenProjection(width, height)
  if (mapId.startsWith('nl-')) return getMercatorNLProjection(width, height)
  if (mapId.startsWith('eu-')) return getMercatorEUProjection(width, height)
  return getEqualEarthProjection(width, height)
}

export function haversineKm(a: [number, number], b: [number, number]): number {
  const [lon1, lat1] = a
  const [lon2, lat2] = b
  const R = 6371 // Earth's radius in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLon = ((lon2 - lon1) * Math.PI) / 180
  const lat1Rad = (lat1 * Math.PI) / 180
  const lat2Rad = (lat2 * Math.PI) / 180

  const aVal =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) *
      Math.sin(dLon / 2) *
      Math.cos(lat1Rad) *
      Math.cos(lat2Rad)
  const c = 2 * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal))
  return R * c
}
